var _paq = _paq || [];
var karsaMonitorCollector = (function () {
    var supportJsHostUrl = 'https://collector.karsa-monitor.com';
    var serviceHostUrl = 'https://collector.karsa-monitor.com';
    _paq.push(['setTrackerUrl', serviceHostUrl + '/Collect.aspx']);
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = supportJsHostUrl + '/collector-support.js'; s.parentNode.insertBefore(g, s);
    var productsDataPacks = [];

    var cookieNameForHasCreatedOrder = "km_o";
    var cookieNameForVisitorGeneratedID = "km_v";
    var cookieNameForLastVisitTime = "km_l";
    var cookieNameForIsReturningVisitor = "km_r";
    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }
    function setCookie(name, value) {
        expirationDate = new Date(2037,1,1,0,0,0,0);
        document.cookie = name+"="+value+"; expires=" + expirationDate.toUTCString() + "; path=/";
    }
    function generateVisitorId() {
        date = new Date()
        var timePrefix = (date.getHours() % 16).toString(16) + (date.getMinutes() % 16).toString(16) + (date.getSeconds() % 16).toString(16) + (date.getMilliseconds() % 16).toString(16);
        return timePrefix + ("0123456789ABCDEF".replace(/./g, c => (crypto.getRandomValues(new Uint8Array(1))[0] & 15).toString(16)));
    }
    if (!getCookie(cookieNameForVisitorGeneratedID)) {
        setCookie(cookieNameForVisitorGeneratedID, generateVisitorId());
    }
    var lastVisitTimeCookieValue = getCookie(cookieNameForLastVisitTime);
    if (lastVisitTimeCookieValue) {
        var lastVisitTime = parseInt(lastVisitTimeCookieValue);
        var elapsedMinutesSinceLastVisit = ((new Date()).getTime() - lastVisitTime) / 60000;
        if (elapsedMinutesSinceLastVisit > 20) {
            setCookie(cookieNameForIsReturningVisitor, "1");
        }
    }
    return {
        addProduct: function (code, price) {
            var productsData = productsDataPacks[productsDataPacks.length-1];
            if (!productsData) { productsDataPacks.push(productsData=[]); }
            productsData.push(code);
            productsData.push(price);
            if (JSON.stringify(productsData).length > 50) {
                productsDataPacks.push([productsData[productsData.length-2], productsData[productsData.length-1]]);
                productsData.length -= 2;
            }
        },
        send: function (eshopId, timeHash) {
            setCookie(cookieNameForLastVisitTime, (new Date()).getTime().toString());
            _paq.push(['setSiteId', eshopId]);
            _paq.push(['enableLinkTracking']);
            for (var pack = 0; pack < productsDataPacks.length; pack++) {
                _paq.push(['setCustomVariable', 1, 'products_v1', JSON.stringify(productsDataPacks[pack]), 'page']);
                _paq.push(['setCustomVariable', 2, 'hash_v1', timeHash || '', 'page']);
                _paq.push(['trackPageView']);
            }
            if (productsDataPacks.length === 0) {
                _paq.push(['setCustomVariable', 2, 'hash_v1', timeHash || '', 'page']);
                _paq.push(['trackPageView']);
            }
            productsDataPacks = [];
        },
        sendOrder: function (eshopId, orderNumber) {
            setCookie(cookieNameForHasCreatedOrder, "1");
            _paq.push(['setSiteId', eshopId]);
            _paq.push(['trackEcommerceOrder', orderNumber, 0]);
            _paq.push(['enableLinkTracking']);
        }
    };
})();